export default class BaseModalForm {
    constructor() {
        this.init()
    }

    get modalElement() {
    }

    get formElement() {
    }

    notify = {
        element: this.modalElement.querySelector('.js-message-block'),
        set(message) {
            this.element.innerHTML = message
        },
        error(message, clearAfter = null) {
            this.set(message)
            this.element.classList.add('has-error')

            if (clearAfter) {
                return this.clear(clearAfter)
            }
        },
        success(message, clearAfter = null) {
            this.set(message)
            this.element.classList.add('has-success')

            if (clearAfter) {
                return this.clear(clearAfter)
            }
        },
        clear() {
            this.set('')
        }
    }

    reset() {
        this.formElement.reset()
        this.notify.clear()

        setTimeout(() => this.close(), 300)
    }

    init() {
    }

    run(onSubmit, open = true) {
        $(this.formElement).off('submit')
        open && this.open()
        $(this.formElement).on('submit', event => {
            event.preventDefault()
            onSubmit(() => this.reset())
            return false
        })
    }

    open() {
        setTimeout(() => {
            $.magnificPopup.open({
                items: {
                    src: $(this.modalElement),
                },
                type: 'inline',
                fixedContentPos: false,
                fixedBgPos: true,
                overflowY: 'auto',
                closeBtnInside: true,
                preloader: false,
                midClick: true,
                removalDelay: 300,
                mainClass: 'mfp-with-zoom',
                callbacks: {
                    close: () => this.reset()
                }
            });
        }, 300)

    }

    close() {
        $.magnificPopup.close();
    }
}
